import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import DirectoryHome from './components/DirectoryHome';
import CityLandingPage from './components/CityLandingPage';
import ListingDetails from './components/ListingDetails';
import About from './components/About';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import Terms from './components/Terms';
import ListBusiness from './components/ListBusiness';
import Privacy from './components/Privacy';
import SearchResults from './components/SearchResults';
import './App.css';

function App() {
  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<DirectoryHome />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/:citySlug" element={<CityLandingPage />} />
          <Route path="/listing/:listingId" element={<ListingDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/list-your-business" element={<ListBusiness />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;